const white = '#FFFFFF';
const black = '#131112';
const gradientLight = 'rgba(255, 255, 255, 0)';
const gradientDark = 'rgba(255, 255, 255, 1)';

const neutrals = {
  n100: '#E0DBDB',
  n300: '#F7F7F7',
  n400: '#E8E8E8',
  n500: '#D8D8D8',
  n550: '#DCDCDC',
  n600: '#797979',
  n650: '#666666',
  n700: '#A4A4A4',
  n800: '#ABABAB',
  n850: '#595959',
  n900: '#606060',
};

const greens = {
  g100: '#EBFFE4',
  g200: '#EFF5F2',
  g300: '#F4FCF1',
  g500: '#44be74',
  g600: '#008A15',
  g700: '#30AB46',
  g800: '#67BE41',
  g900: '#008A15',
  g950: '#5CBD31',
};

const blues = {
  bl100: '#0C1945',
  bl300: '569BDD',
  bl500: '#40b5de',
  bl900: '#09345C',
};

const oranges = {
  o300: '#fcb602',
  o400: '#FF8119',
  o500: '#E68835',
  o700: '#FF8219',
  o900: '#B52F01',
};

const yellows = {
  y500: '#ffde3c',
};

const reds = {
  r300: '#F13753',
  r500: '#C8102E',
  r700: '#880A1E',
  r600: '#BE3F36',
};

const browns = {
  b100: '#654D4D',
  b200: '#D1C9CA',
  b300: '#8D7171',
  b400: '#3F2021',
  b500: '#432726',
  b900: '#572D2D',
};

const primary = {
  red: reds.r500,
};

const misc = {
  white50: 'rgba(255, 255, 255, 0.50)',
  shadow: 'rgba(0,0,0,0.75)',
  textShadow: 'rgba(84, 84, 84, 1)',
  bodyColor: black,
  headerBg: '#131112',
  headerBg90: 'rgba(17, 15, 16, 0.9)',
  sectionBg: '#F2F2F2',
  darkBg: '#0D1824',
  danger: reds.r500,
  success: greens.g700,
  warning: oranges.o500,
};

const teams = {
  anaheim: '#FC4C02',
  arizona: '#AE3142',
  boston: '#FFB81C',
  buffalo: '#041E42',
  calgary: '#C8102E',
  carolina: '#C00000',
  chicago: '#CE1126',
  colorado: '#8A2432',
  columbus: '#041E42',
  dallas: '#006341',
  detroit: '#CE1126',
  edmonton: '#091F40',
  florida: '#C8102E',
  losAngeles: '#A2AAAD',
  lasVegas: '#85714D',
  minnesota: '#154734',
  montreal: '#AF1E2D',
  nashville: '#041E42',
  newJersey: '#C00000',
  newYorkIslanders: '#00529B',
  newYorkRangers: '#00428D',
  ottawa: '#E21A32',
  philadelphia: '#FA4616',
  phoenix: '#AE3142',
  pittsburgh: '#FFB81C',
  sanJose: '#006272',
  stLouis: '#002F87',
  tampaBay: '#00205B',
  toronto: '#003D7D',
  vancouver: '#002D55',
  washington: '#041E42',
  winnipeg: '#002D61',
};
const heatStreak = {
  image: {
    start: '#8E8D92',
    end: '#8E8D92',
  },
  cold: {
    start: '#60a1df',
    end: '#60a1df',
  },
  hot: {
    start: '#FF8119',
    end: '#FF8119',
  },
  h0: {
    start: '#818181',
    end: '#4c4c4c',
  },
  h1: {
    start: '#C3AC5F',
    end: '#FFBE00',
  },
  h2: {
    start: '#FFBE00',
    end: ' #C1660E',
  },
  h3: {
    start: '#FFBE00',
    end: '#FF7300',
  },
  h4: {
    start: '#FF8119',
    end: '#D14D09',
  },
  h5: {
    start: '#FF0201',
    end: '#850100',
  },
  h6: {
    start: '#FF0201',
    end: '#D70600',
  },
  h7: {
    start: '#FF0000',
    end: '#FF0000',
  },
};

export const colors = {
  white,
  black,
  gradientLight,
  gradientDark,
  ...neutrals,
  ...greens,
  ...reds,
  ...blues,
  ...yellows,
  ...oranges,
  ...browns,
  ...primary,
  ...misc,
  ...teams,
  heatStreak,
};
